import React, { useState,useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "../../Auth/AuthContext";
// import Login from "../../Login/Login";

export default function PrivateRoute({ component: Component, scopes, ...rest }) {
    const [showRoute,setRoute] = useState(false);
 
    async function hasRoleName() {
        return await localStorage.getItem('roleName');
    }

    useEffect(()=>{
      
        let loginTime = localStorage.getItem('loginTime')
        let currentTime = Date.now()
        let timeDifference = (currentTime - loginTime) / 1000 / 60

        if (timeDifference > 29 && localStorage.getItem('isInDashboard')==null ) {
            setRoute(false)
        }else{
            setRoute(true)
        }
    })

    return (
        <AuthContext.Consumer>
            {auth => (
                    <Route
                        {...rest}
                        render={props => {
                          
                            //Redirect to login screen if user is not logged in
                         
                         
                            //isScopesLoaded is to prevent loading the unauthorization component before the authorized component
                            if (auth.isScopesLoaded && !localStorage.getItem('roleName')) {
                                return (<Redirect to={{ pathname: "/unauthorized" }} />);
                            }
                            //Redirect to unauthorized screen if user doesn't have scopes
                            if (auth.isScopesLoaded && scopes && scopes.length > 0 && !auth.userHasScopes(scopes)) {

                                return (<Redirect to={{ pathname: "/unauthorized" }} />);
                            }
                           
                            //Render component
                            if(showRoute){
                               
                                return  <Component auth={auth} {...props} />
                           }
                        }}
                    />
            )}
        </AuthContext.Consumer>
    )
} 
